module.exports = __webpack_public_path__ + "img/silver.8368e73d.png";